import { EventChangesBody } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/EventChangesBody";
import { PlanEventInformation } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import { FC } from "react";
import { Stack } from "shared/components/Spor";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { FCWC } from "shared/utils/FCWC";
import { useTheme } from "styled-components";

type EventChangesComparisonProps = {
  previousEvent: PlanEventInformation;
  latestEvent: CombinedHistoryResponse;
};

const Wrapper: FCWC = ({ children }) => {
  const theme = useTheme();
  return (
    <Stack
      border={`1px solid color-mix(in srgb, ${theme.colorOutlineMain} 20%, transparent)`}
      borderRadius="md"
      backgroundColor={theme.colorBackgroundSecondary}
      m="1"
      p="3"
      gap="3"
    >
      {children}
    </Stack>
  );
};

export const EventChangesComparison: FC<EventChangesComparisonProps> = ({
  previousEvent,
  latestEvent,
}) => (
  // TODO: Include internal messages on current version
  <Wrapper>
    <EventChangesBody
      currentInformation={latestEvent}
      previousInformation={previousEvent.information}
      currentInternalMessages={previousEvent.internalMessages} // TODO: Swap to latestEvent
      previousInternalMessages={previousEvent.internalMessages}
    />
  </Wrapper>
);
